import styled from "styled-components";

// Modal Container - Agora como overlay fixo
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(37, 63, 115, 0.4);
  z-index: 9999;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const MissionModalSidebar = styled.div`
  width: 690px;
  height: 100vh;
  background: white;
  border-right: 1px #e9e9e9 solid;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  box-shadow: 0px 4px 12px rgba(23, 42, 63, 0.1);
`;

// Header Section
export const MissionModalHeader = styled.div`
  align-self: stretch;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 24px;
  padding-bottom: 24px;
  overflow: hidden;
  border-bottom: 1px #e9e9e9 solid;
  justify-content: flex-start;
  align-items: center;
  display: flex;
`;

export const HeaderLeftSection = styled.div`
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
`;

export const MissionModalTitle = styled.span`
  color: #172a3f;
  font-size: 20px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
`;

export const HeaderRightSection = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2px;
  display: flex;
`;

export const CloseModalButton = styled.div`
  border-radius: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: inline-flex;
  cursor: pointer;
  padding: 8px;

  &:hover {
    background: #f4f4f4;
  }
`;

export const CloseButtonLabel = styled.span`
  color: #606060;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const CloseButtonIcon = styled.div`
  width: 20px;
  height: 20px;
  position: relative;

  svg {
    width: 100%;
    height: 100%;
  }
`;

// Main Content Section
export const MissionModalBody = styled.div`
  align-self: stretch;
  flex: 1 1 0;
  min-height: 0;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 24px;
  padding-bottom: 0;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
  overflow: hidden;
`;

export const MissionFormContainer = styled.div`
  align-self: stretch;
  flex: 1 1 0;
  min-height: 0;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  display: flex;
`;

// Input Master Container
export const MissionNameInputContainer = styled.div`
  align-self: stretch;
  overflow: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0;
  display: flex;
  outline: 1px #d1d1d1 solid;
  outline-offset: -1px;
  border-radius: 4px;
`;

export const MissionNameLabel = styled.span`
  color: #606060;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
  padding: 8px 12px 0 12px;
`;

export const MissionNameInputWrapper = styled.div`
  align-self: stretch;
  height: 30px;
  padding-left: 12px;
  padding-right: 12px;
  position: relative;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
`;

export const MissionNameInputContent = styled.div`
  flex: 1 1 0;
  padding-right: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  display: inline-flex;
`;

export const MissionNameInputField = styled.input`
  border: none;
  outline: none;
  background: transparent;
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  width: 100%;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    color: #888;
  }
`;

export const VehicleTypeSelect = styled.select`
  border: none;
  outline: none;
  background: transparent;
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  width: 100%;
  cursor: pointer;
`;

export const MissionNameHelperText = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  display: inline-flex;
`;

export const HelperTextIcon = styled.div`
  width: 12px;
  height: 12px;
  position: relative;
  display: flex;
  align-items: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const MissionNameHelperMessage = styled.span`
  color: #004ecc;
  font-size: 10px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 12px;
  word-wrap: break-word;
`;

export const MissionDetailsContainer = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: flex;
`;

// Mission Steps Empty State
export const MissionStepsEmptyState = styled.div`
  align-self: stretch;
  flex: 1 1 0;
  min-height: 0;
  padding: 8px;
  outline: 1px #e9e9e9 solid;
  outline-offset: -1px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
  overflow: hidden;
`;

export const StopsScrollContainer = styled.div`
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  width: 100%;
`;

export const MissionStepsHeader = styled.div`
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  display: flex;
`;

export const MissionStepsTitle = styled.span`
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 500;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const AddStepButtonsContainer = styled.div`
  align-self: stretch;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  display: flex;
`;

export const AddStationStepButton = styled.button`
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 6px;
  padding-bottom: 6px;
  outline: 2px #3f7f7d solid;
  outline-offset: -2px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  display: flex;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background: #f4f4f4;
  }
`;

export const AddActionStepButton = styled.button<{ disabled?: boolean }>`
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 6px;
  padding-bottom: 6px;
  outline: 2px ${(props) => (props.disabled ? "#cccccc" : "#3f7f7d")} solid;
  outline-offset: -2px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  display: flex;
  background: transparent;
  border: none;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border-radius: 4px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &:hover {
    background: ${(props) => (props.disabled ? "transparent" : "#f4f4f4")};
  }
`;

export const AddStepButtonIcon = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
`;

export const AddStepButtonText = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
`;

export const AddStepButtonLabel = styled.span<{ disabled?: boolean }>`
  color: ${(props) => (props.disabled ? "#999999" : "#3f7f7d")};
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 19.6px;
  word-wrap: break-word;
`;

// Example Mission Step Row
export const ExampleMissionStepRow = styled.div`
  align-self: stretch;
  width: 100%;
  padding: 8px;
  background: #f4f4f4;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0;
  display: flex;
  flex-direction: column;
`;

export const MissionStepRowContent = styled.div`
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
  min-width: 0; // Allow flex items to shrink
  width: 100%;
  align-self: stretch; // Ensure it stretches to full width
`;

export const MissionStepControls = styled.div`
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
  min-width: 0; // Allow flex items to shrink
  width: 100%; // Take full available width
`;

export const DragHandle = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "grab")};
  color: ${(props) => (props.disabled ? "#ccc" : "#666")};
  transition: color 0.2s ease;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  flex-shrink: 0; // Prevent shrinking
  width: 32px; // Fixed width
  height: 32px; // Fixed height

  &:hover {
    color: ${(props) => (props.disabled ? "#ccc" : "#333")};
  }

  &:active {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "grabbing")};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

// Station Dropdown Styles
export const StationDropdownContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 8px;
  background: white;
  outline: 1px #e9e9e9 solid;
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  border-radius: 4px;
  cursor: pointer;
  position: relative;

  &:hover {
    outline: 2px #55b8b3 solid;
    outline-offset: -2px;
  }
`;

export const StationDropdownContent = styled.div`
  flex: 1 1 0;
  padding-left: 8px;
  padding-right: 4px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
`;

export const StationDropdownPlaceholder = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2px;
  display: inline-flex;
`;

export const StationDropdownLabel = styled.span`
  color: #606060;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

export const StationDropdownValue = styled.div`
  align-self: stretch;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  display: inline-flex;
`;

export const StationDropdownValueText = styled.span`
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const StationDropdownIcon = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const DropdownSelectIcon = styled.div`
  width: 24px;
  height: 24px;
  left: 0px;
  top: 0px;
  position: absolute;
  overflow: hidden;
`;

export const DropdownSelectIconShape = styled.div`
  width: 15.41px;
  height: 8.71px;
  left: 4.29px;
  top: 9px;
  position: absolute;
  background: #767676;
`;

export const StationDropdownOptions = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px #e9e9e9 solid;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0px 4px 12px rgba(23, 42, 63, 0.1);
`;

export const StationDropdownOption = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;

  &:hover {
    background: #f4f4f4;
  }

  &:first-child {
    border-radius: 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;

// Autocomplete Search Styles
export const SearchContainer = styled.div`
  padding: 18px 12px 8px 12px;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f4f4f4;
  display: flex;
`;

export const SearchIconWrapper = styled.div`
  /* position: sticky;
  left: 20px;
  top: 50%; */
  /* transform: translateY(-50%); */
  z-index: 1;
  pointer-events: none;

  svg {
    width: 16px;
    height: 16px;
    color: #666;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 1px 12px 8px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  background-color: #f4f4f4;
  color: #606060;
  font-family: "Readex Pro", sans-serif;
  font-weight: 300;
`;

export const SearchResultsContainer = styled.div`
  /* padding-top: 40px; */
`;

export const NoResultsMessage = styled.div`
  padding: 12px;
  text-align: center;
  color: #666;
  font-size: 14px;
`;

// Version Dropdown Styles
export const VersionDropdownContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 8px;
  background: white;
  outline: 1px #e9e9e9 solid;
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  border-radius: 4px;
  cursor: pointer;
  position: relative;

  &:hover {
    outline: 2px #55b8b3 solid;
    outline-offset: -2px;
  }
`;

export const VersionDropdownContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const VersionDropdownLabel = styled.span`
  color: #999999;
  font-size: 12px;
  font-family: "Readex Pro", sans-serif;
  font-weight: 400;
  line-height: 16px;
`;

export const VersionDropdownValue = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const VersionDropdownValueText = styled.span`
  color: #0d0d0d;
  font-size: 14px;
  font-family: "Readex Pro", sans-serif;
  font-weight: 400;
  line-height: 20px;
`;

export const VersionDropdownIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const VersionDropdownOptions = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 4px;
  max-height: 300px;
  overflow-y: auto;
`;

export const VersionDropdownOption = styled.div`
  padding: 12px;
  cursor: pointer;
  color: #0d0d0d;
  font-size: 14px;
  font-family: "Readex Pro", sans-serif;
  font-weight: 400;
  line-height: 20px;

  &:hover {
    background: #f5f5f5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;

// Action Dropdown Styles
export const ActionDropdownContainer = styled.div<{ disabled?: boolean }>`
  ${(props) => (props.disabled ? "width: 250px;" : "width: 100%;")}
  height: 100%;
  padding: 8px;
  background: ${(props) => (props.disabled ? "#F4F4F4" : "white")};
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  position: relative;

  &:hover {
    outline: ${(props) =>
      props.disabled ? "1px #E9E9E9 solid" : "2px #55B8B3 solid"};
    outline-offset: -${(props) => (props.disabled ? "1px" : "2px")};
  }
`;

export const ActionDropdownContent = styled.div<{ disabled?: boolean }>`
  flex: 1 1 0;
  padding-left: 8px;
  padding-right: 4px;
  flex-direction: ${(props) => (props.disabled ? "row" : "column")};
  justify-content: ${(props) => (props.disabled ? "flex-start" : "flex-start")};
  align-items: ${(props) => (props.disabled ? "center" : "flex-start")};
  display: inline-flex;
  gap: ${(props) => (props.disabled ? "8px" : "2px")};
  width: 155px;
`;

export const ActionDropdownPlaceholder = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2px;
  display: inline-flex;
`;

export const ActionDropdownLabel = styled.span<{ disabled?: boolean }>`
  color: ${(props) => (props.disabled ? "#A4A4A4" : "#606060")};
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

export const ActionDropdownValue = styled.div`
  align-self: stretch;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  display: inline-flex;
`;

export const ActionDropdownValueText = styled.span<{ disabled?: boolean }>`
  color: #1b1b1b;
  font-size: 15px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const ActionDropdownIcon = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const ActionClockIcon = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const ActionDropdownOptions = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px #e9e9e9 solid;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0px 4px 12px rgba(23, 42, 63, 0.1);
`;

export const ActionDropdownOption = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;

  &:hover {
    background: #f4f4f4;
  }

  &:first-child {
    border-radius: 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;

// Trigger Type Dropdown Styles
export const TriggerTypeDropdownContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 8px;
  background: white;
  outline: 1px #e9e9e9 solid;
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  border-radius: 4px;
  cursor: pointer;
  position: relative;

  &:hover {
    outline: 2px #55b8b3 solid;
    outline-offset: -2px;
  }
`;

export const TriggerTypeDropdownContent = styled.div`
  flex: 1 1 0;
  padding-left: 8px;
  padding-right: 4px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
`;

export const TriggerTypeDropdownPlaceholder = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2px;
  display: inline-flex;
`;

export const TriggerTypeDropdownLabel = styled.span`
  color: #606060;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

export const TriggerTypeDropdownValue = styled.div`
  align-self: stretch;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  display: inline-flex;
`;

export const TriggerTypeDropdownValueText = styled.span`
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const TriggerTypeDropdownIcon = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const TriggerTypeDropdownOptions = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px #e9e9e9 solid;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0px 4px 12px rgba(23, 42, 63, 0.1);
`;

export const TriggerTypeDropdownOption = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;

  &:hover {
    background: #f4f4f4;
  }

  &:first-child {
    border-radius: 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;

// Duration Dropdown Styles
export const DurationInputContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 8px;
  background: white;
  outline: 1px #e9e9e9 solid;
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  border-radius: 4px;
  position: relative;

  &:hover {
    outline: 2px #55b8b3 solid;
    outline-offset: -2px;
  }

  &:focus-within {
    outline: 2px #55b8b3 solid;
    outline-offset: -2px;
  }
`;

export const DurationInputContent = styled.div`
  flex: 1 1 0;
  padding-left: 8px;
  padding-right: 4px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
`;

export const DurationInputPlaceholder = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2px;
  display: inline-flex;
`;

export const DurationInputLabel = styled.span`
  color: #606060;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

export const DurationInputField = styled.input`
  border: none;
  outline: none;
  background: transparent;
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  width: 100%;
  padding: 0;
`;

// Action Container - Fixed width for action dropdown
export const ActionContainer = styled.div`
  width: 250px;
  height: 56px;
  padding: 8px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
`;

// Station Container - Responsive width
export const StationContainer = styled.div`
  flex: 1 1 0;
  height: 56px;
  padding: 8px;
  background: white;
  outline: 1px #e9e9e9 solid;
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
`;

// Trigger Type Container - Responsive width
export const TriggerTypeContainer = styled.div<{ isCountdown?: boolean }>`
  ${(props) =>
    props.isCountdown
      ? `
      width: 200px;
      height: 56px;
      padding: 8px;
      background: white;
      outline: 1px #E9E9E9 solid;
      outline-offset: -1px;
      justify-content: flex-start;
      align-items: center;
      display: flex;
    `
      : `
      flex: 1 1 0;
      height: 56px;
      padding: 8px;
      background: white;
      outline: 1px #E9E9E9 solid;
      outline-offset: -1px;
      justify-content: flex-start;
      align-items: center;
      display: flex;
    `}
`;

// Duration Container - Fixed width for countdown
export const DurationContainer = styled.div`
  width: 80px;
  height: 56px;
  padding: 8px;
  background: white;
  outline: 1px #e9e9e9 solid;
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
`;

// Action Controls Container - Should fill available space
export const ActionControlsContainer = styled.div`
  align-self: stretch;
  padding: 8px 32px 8px 8px;
  background: #f4f4f4;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
  min-width: 0; // Allow flex items to shrink
  margin-top: 0;
  width: 100%;
  position: relative;
`;

export const RemoveActionIcon = styled.div`
  width: 18px;
  height: 18px;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }

  &:hover {
    opacity: 0.7;
  }
`;

// Checkbox Styles
export const UnhitchCheckboxContainer = styled.div`
  width: 100px;
  height: 56px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

export const UnhitchCheckbox = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

export const UnhitchCheckboxRing = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
`;

export const UnhitchCheckmarkRing = styled.div`
  width: 24px;
  height: 24px;
  left: 0px;
  top: 0px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const UnhitchCheckboxShape = styled.div`
  width: 20px;
  height: 20px;
  left: 2px;
  top: 2px;
  position: absolute;
  background: #a4a4a4;
`;

export const UnhitchCheckboxText = styled.div`
  padding-top: 2px;
  padding-bottom: 2px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

export const UnhitchCheckboxLabel = styled.span`
  color: #606060;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const RemoveStepIcon = styled.div`
  width: 18px;
  height: 18px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const RemoveStepIconShape = styled.div`
  width: 11.56px;
  height: 11.56px;
  left: 3.22px;
  top: 3.22px;
  position: absolute;
  background: #767676;
`;

// Footer Section
export const MissionModalFooter = styled.div`
  align-self: stretch;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 24px;
  padding-bottom: 24px;
  border-top: 1px #e9e9e9 solid;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  display: flex;
`;

export const FooterButtonsContainer = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: inline-flex;
`;

export const CancelMissionButton = styled.button`
  flex: 1 1 0;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  outline: 2px #d1d1d1 solid;
  outline-offset: -2px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: flex;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background: #f4f4f4;
  }
`;

export const CreateMissionButton = styled.button`
  flex: 1 1 0;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  background: #3f7f7d;
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: flex;
  border: none;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background: #2f5f5d;
  }

  &:disabled {
    background: #cccccc;
    cursor: not-allowed;

    &:hover {
      background: #cccccc;
    }
  }
`;

export const ButtonTextContainer = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
`;

export const CancelButtonText = styled.span`
  color: #1b1b1b;
  font-size: 20px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
`;

export const CreateButtonText = styled.span`
  color: white;
  font-size: 20px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;

  ${CreateMissionButton}:disabled & {
    color: #999999;
  }
`;

// Validation Error Styles
export const UnhitchWarningBodyStyled = styled.div`
  height: 44px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-top: 1px solid #f4f4f4;
  border-bottom: 1px solid #f4f4f4;
  margin-bottom: 10px;
`;

export const UnhitchTextWarningStyled = styled.div`
  font-size: 14px;
  line-height: 140%;
`;

export const UnhitchWarningIconStyled = styled.div`
  height: 34px;
  width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f0d1d1;
`;
